export default __webpack_public_path__ + "static/media/Group_12505.1fa9be45.svg";